'use strict';

var _ = require('lodash');
var AngularHelper = function AngularHelper($injector, $log) {
  function digestWrapper(scope, func) {
    return function () {
      func.apply(this, arguments);
      triggerDigest(scope);
    };
  }
  function applyWrapper(scope, func) {
    return function () {
      func.apply(this, arguments);
      triggerApply(scope);
    };
  }
  function triggerDigest(scope) {
    if (scope.$root.$$phase !== '$apply' && scope.$root.$$phase !== '$digest') {
      scope.$digest();
    }
  }
  function triggerApply(scope) {
    if (scope.$root.$$phase !== '$apply' && scope.$root.$$phase !== '$digest') {
      scope.$apply();
    }
  }
  function dumpScopes(parentScope) {
    function traverse(scope, level) {
      var watchers = scope.$$watchers;
      var numOfWatchers = watchers ? watchers.length : 0;
      var childrenWatchers = numOfWatchers;
      for (var cs = scope.$$childHead; cs; cs = cs.$$nextSibling) {
        childrenWatchers += traverse(cs, level + 1);
      }
      $log.debug(_.repeat('\t', level), 'Id:', scope.$id, '# of watchers', numOfWatchers, '# of children watchers', childrenWatchers);
      return numOfWatchers + childrenWatchers;
    }
    var allWatchers = traverse(parentScope, 0);
    $log.debug('Number of all watchers', allWatchers);
  }

  /**
   * Retrieves provider (factories, services) by name.
   * Module (!!!) should be hooked up (connected) before retrieving
   * @param {Array.<string>} providerListNames
   * @returns {Array.<Object>} - array of providers retrieved by name
   */
  function getProvidersByNames(providerListNames) {
    return _.transform(providerListNames, function (result, providerName) {
      result.push($injector.get(providerName));
    });
  }
  return {
    digestWrapper: digestWrapper,
    applyWrapper: applyWrapper,
    triggerDigest: triggerDigest,
    triggerApply: triggerApply,
    dumpScopes: dumpScopes,
    getProvidersByNames: getProvidersByNames
  };
};
AngularHelper.$inject = ['$injector', '$log'];
module.exports = AngularHelper;